import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUserTab = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 17,
	height: 16,
	viewBox: "0 0 17 16",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("path", {
		d: "M8.5013 7.99967C10.3423 7.99967 11.8346 6.50729 11.8346 4.66634C11.8346 2.82539 10.3423 1.33301 8.5013 1.33301C6.66035 1.33301 5.16797 2.82539 5.16797 4.66634C5.16797 6.50729 6.66035 7.99967 8.5013 7.99967Z",
		stroke: "",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M14.2268 14.6667C14.2268 12.0867 11.6601 10 8.5001 10C5.3401 10 2.77344 12.0867 2.77344 14.6667",
		stroke: "",
		strokeWidth: 1.5,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})]
});
export default SvgUserTab;
